import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Table } from "reactstrap";
import Layout from "components/Layout";
import { OuterWrapper } from "assets/css/global";
import HeadingIcon from "assets/svg/InvoiceIcon";
import { BodyContainer } from "styles/pages/global";
import { InvoiceWrapper, Heading, TopHeading } from "styles/pages/invoice";
import * as moment from "moment";
import { FORMAT } from "utils/dateOfBirthValidation";
import InvoiceTable from "./invoiceTable";
import HeadingSection from "./headingSection";
import Pagination from "components/pagination";
import { useDispatch } from "react-redux";
import { useCallback } from "react";
import { invoiceTableRecords } from "redux/actions/invoice";
import { adminFetchLocationListApi } from "redux/actions/manageAccount";
import { InvoiceTableContainer } from "./invoiceTable/InvoiceTableStyle";
import MaterialToolTip from "components/MaterialToolTip";
import AlertModal from "components/AlertModal";
import { sortListOfObjects } from 'helpers'
import { useText } from "locales/useGetText";
//ComponentStart
const InvoicesPage = () => {
  const navigate = useNavigate();
  const locale = useText("invoices");
  const loggedInUserInfo = JSON.parse(localStorage.getItem('loggedInUserData'))
  const token = loggedInUserInfo?.token
  const customerId = loggedInUserInfo?.customerId
  // TableHeading
  let accordionTableArrHeader = [
    locale('locationAddress'),
    locale('invoiceRemitNumber'),
    locale('documentDate'),
    // "Invoice Period",
    // "No. Of Loads",
    locale('totalInvoiceAmount'),
    // "Invoice Status",
    // "Paid Date",
    locale('orderType'),
   locale('downloadInvoice'),
  ];
  //    "Total Invoice Amt.(Inc.Tax/Fee)",
  const [orderResponse, setOrderResponse] = useState(null);
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [modalLink, setModalLink] = useState("/");
  const toggleModal = () => setModal(!modal);

  // pagination
  const [pageNumber, setPageNumber] = useState(0);
  const [totalPagesCount, setTotalPagesCount] = useState(0);

  const onPageChange = (page) => {
    handleFilterChange("number", page - 1)
    setPageNumber(page);
  };
  //Dispatch hook asssign it to dispatch
  const dispatch = useDispatch();

  //if not have token navigate to home/
  useEffect(() => {
    if (!token) {
      navigate("/");
    } else {
      fetchLocationListFunction();
    }
  }, []);

  //these are the payloads(filters) we get after hitting that api with post method
  let fromDate = moment(new Date().setMonth(new Date().getMonth() - 6)).format(FORMAT)
  let toDate = moment(new Date()).format(FORMAT)

  const [filter, setFilter] = useState({
    locations: [],
    findAll: false,
    size: 10,
    number: 0,
    sort: "DESC",
    doSearch: false,
    status: null,
    invoiceSchedule: null,
    searchBy: "",
    fromDate: new Date(fromDate) / 1000,
    toDate: (new Date(toDate) / 1000) + 86399, // epoch value taked 12 am, so adding the milliseconds to get the 11 59pm of the day
  });

  const [locationRes, setLocationsRes] = useState();

  const fetchLocationListFunction = async (type) => {
    let response = "";
    response = await dispatch(adminFetchLocationListApi(loggedInUserInfo?.locationType, customerId, token));
    if (response?.success) {
      let mainLocationtemp = response?.data?.locations?.map(val => val.mainLocation);
      let subLocationtemp = response?.data?.locations?.flatMap(val => val.subLocations || [])
      let locationTemp = [...mainLocationtemp]
      if (subLocationtemp && subLocationtemp.length > 0) {
        locationTemp = [...mainLocationtemp, ...subLocationtemp];
      }
      locationTemp = sortListOfObjects("string", locationTemp, "asc", "address.locationName") // sort alphabetically

      let arr = []
      for (let i = 0; i < locationTemp.length; i++) {
        let obj = {
          label: locationTemp[i].address.locationName,
          value: locationTemp[i].locationId,
        }
        arr.push(obj)
        if (i === locationTemp.length - 1) {
          setLocationsRes(arr);
          let locationArr = locationTemp?.map(val => val.locationId)
          if (locationArr && locationArr.length !== 0) {
            setFilter({ ...filter, locations: locationArr });
          }
        }
      }
    } else {
      if (response?.error.message === "Invalid Token") {
        navigate("/");
      } else {
        setModalContent(response?.data?.error?.message || response.message || locale('genericErrorLater'));
        setModalLink("");
        toggleModal();
        setTotalPagesCount("");
        setLocationsRes(null);
      }
    }
  };

  useEffect(() => {
    if (locationRes && locationRes.length > 0) fetchMyApi();
  }, [filter, locationRes]);

  const fetchMyApi = useCallback(async () => {
    let data = filter;
    let response = await dispatch(invoiceTableRecords(data, token));
    if (response?.data?.success) {
      setOrderResponse(response?.data?.data);
      setTotalPagesCount(response?.data?.data?.totalElements);
    } else {
      if (response?.data?.error.code === 400) {
        setOrderResponse(null);
        setTotalPagesCount("");
      } else if (response?.data?.error.message === "Invalid Token") {
        navigate("/");
      } else {
        setModalContent(response?.data?.error?.message || response.message || locale('genericErrorLater'));
        setModalLink("");
        toggleModal();
        setTotalPagesCount("");
        setOrderResponse(null);
      }
    }
  });

  const handleFilterChange = (name, value) => {
    filter.number = 0
    setFilter({
      ...filter,
      findAll: false,
      doSearch: name === "searchBy" && value !== "" ? true : false,
      [name]: value,
    });
    setPageNumber(1)
  };

  const formFields = () => {
    return (
      <Layout activeTab="Invoice">
        <OuterWrapper>
          <TopHeading>
            <div className="icon-text-wrapper">
              <HeadingIcon className="order-invoice-icon" />
              <Heading>
                <h4>{locale('myOrderInvoice')}</h4>
                <span style={{ transform: "scale(.7)", marginTop: "1px" }}>
                  <MaterialToolTip title={locale('displaying180Days')} class="passwordIcon" infoIcon={true} className={`font-11`} />
                </span>
              </Heading>
            </div>
            <HeadingSection
              filter={filter}
              handleFilterChange={handleFilterChange}
              setFilter={setFilter}
              locations={locationRes}
            />
          </TopHeading>
          <InvoiceWrapper>
            {orderResponse?.invoiceList &&
              orderResponse?.invoiceList.length !== 0 ? (<InvoiceTable headerArr={accordionTableArrHeader} orderResponse={orderResponse} />
            ) : (
              <InvoiceTableContainer>
                <Table responsive style={{ width: "100%" }}>
                  <thead>
                    <tr>
                      {accordionTableArrHeader.map((items, index) => (
                        <th key={index}>{items}</th>
                      ))}
                    </tr>
                  </thead>
                </Table>
                <p
                  style={{
                    width: "100%",
                    textAlign: "center",
                    marginTop: "20px",
                    whiteSpace: "nowrap",
                    marginBottom: "20px",
                  }}
                >
                  {locale('noRecordsFound')}
                </p>
              </InvoiceTableContainer>

            )}

            {totalPagesCount && totalPagesCount !== 0 && (
              <Pagination
                totalPage={totalPagesCount}
                currentPage={pageNumber}
                onPageChange={onPageChange}
              />
            )}
          </InvoiceWrapper>
        </OuterWrapper>

        <AlertModal
          isOpen={modal}
          toggle={toggleModal}
          title={locale('alert')}
          content={modalContent}
          link={modalLink}
          className="alert-msg-container"
          InnerClassName="alert-msg"
        />
      </Layout>
    );
  };


  return <BodyContainer>{formFields()}</BodyContainer>;
};

export default InvoicesPage;
